// IntroductionLayout — Amber theme, 70/30 split
//
// Left panel (70%): ContentPanel showing all tool results.
// Right panel (30%): ChatPanel.
// Mobile: ContentPanel stacks above ChatPanel.

import type { ReactNode } from 'react';
import ContentPanel from '../session/ContentPanel';
import type { ToolResult } from '@hooks/useAnnaChat';

interface LayoutProps {
  chatPanel: ReactNode;
  toolResults: ToolResult[];
  accentColor: string;
  isStreaming?: boolean;
  onSubmitAnswer?: (answer: string) => void;
}

export default function IntroductionLayout({
  chatPanel,
  toolResults,
  accentColor,
  isStreaming,
  onSubmitAnswer,
}: LayoutProps) {
  return (
    <div className="flex flex-col md:flex-row h-full">
      <div className="h-[40vh] md:h-full md:w-[70%] overflow-y-auto p-4">
        <ContentPanel
          toolResults={toolResults}
          accentColor={accentColor}
          isStreaming={isStreaming}
          onSubmitAnswer={onSubmitAnswer}
        />
      </div>
      <div className="flex-1 md:flex-none md:w-[30%] min-h-0">
        {chatPanel}
      </div>
    </div>
  );
}
